export const isFullStatic = false
export const staticPath = "/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/.nuxt/static-json"
export const publicPath = "/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"